// extracted by mini-css-extract-plugin
module.exports = {"workoutDecWorkouts":"style_workoutDecWorkouts__2JHrQ","workoutWorkouts":"style_workoutWorkouts__3_VSa","workoutWorkoutTitle":"style_workoutWorkoutTitle__3G9Ne"};